import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useTranslation } from "react-i18next";

function BaseRadioButton({ name, value, optionList, handleChange, disabled = false }) {
    const { t } = useTranslation();
    return (
        <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name={name}
            value={value}
            onChange={handleChange}
            row
            sx={{ width: { xs: "100%", md: "auto" }, columnGap: "1rem", "& label": { margin: 0 }, "& span": { padding: 0 } }}
        >
            {optionList.map((option, index) => {
                return (
                    <FormControlLabel
                        key={index}
                        value={option.value}
                        control={
                            <Radio
                                disabled={disabled}
                                sx={{
                                    "&.Mui-checked": {
                                        color: disabled ? "gray" : "var(--secondary-color)",
                                    },
                                }}
                            />
                        }
                        label={option?.label}
                        sx={{ columnGap: "0.5rem" }}
                    />
                );
            })}
        </RadioGroup>
    );
}

export default BaseRadioButton;